import { render, staticRenderFns } from "./clipboardbutton.vue?vue&type=template&id=016e7ae0&"
import script from "./clipboardbutton.vue?vue&type=script&lang=js&"
export * from "./clipboardbutton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports